import { EditOutlinedIcon, IconButton } from '@shared/components';

interface ChangeDueDateButtonProps {
  onClick: () => void;
}

export default function ChangeDueDateButton(props: Readonly<ChangeDueDateButtonProps>) {
  const { onClick } = props;

  return (
    <IconButton size='small' onClick={onClick}>
      <EditOutlinedIcon
        sx={{
          width: 20,
          height: 20,
          color: (theme) => theme.palette.grey[600],
        }}
      />
    </IconButton>
  );
}
